import {
  MEDICAL_COMPLEXITY_EXPANDED_TEXT,
  type ArasScoreCategoryRow,
} from "./aras-score-types";

/** Built-in categories for UI review when `categories` prop is omitted. */
export const ARAS_SCORE_MOCK_CATEGORIES: ArasScoreCategoryRow[] = [
  {
    id: "medical-complexity",
    label: "Medical complexity",
    points: 1,
    band: "red",
    expandedDetail: MEDICAL_COMPLEXITY_EXPANDED_TEXT,
  },
  {
    id: "therapy-needs",
    label: "Therapy needs",
    points: 2,
    band: "orange",
    expandedDetail: "Some therapy disciplines are ordered but may not include the full 2+ required disciplines (PT, OT, Speech). Ensure at least two distinct therapy disciplines are ordered and clinically justified."
  },
  {
    id: "functional-tolerance",
    label: "Functional tolerance",
    points: 2,
    band: "orange",
    expandedDetail: "The patient shows moderate tolerance with some barriers, making their ability to complete 3 hours of daily therapy unclear. Document strong tolerance through recent successful therapy sessions with minimal assistance and patient engagement."
  },
  {
    id: "baseline-change",
    label: "Baseline change",
    points: 2,
    band: "orange",
    expandedDetail: "The patient experienced moderate decline with partial loss of independence from baseline. Clearly document pre-admission functional level and emphasize the major loss of independence in ADLs, mobility, or cognition."
  },
  {
    id: "diagnosis",
    label: "Diagnosis",
    points: 3,
    band: "green",
    expandedDetail: "The patient has a clear CMS-13 qualifying diagnosis. No improvement needed."
  },
];
